
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"18","cy":"18","r":"18","fill":"#E36161"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.5832 24.4167H24.4165C24.6596 24.4167 24.8928 24.5133 25.0647 24.6852C25.2366 24.8571 25.3332 25.0902 25.3332 25.3333C25.3332 25.5765 25.2366 25.8096 25.0647 25.9815C24.8928 26.1534 24.6596 26.25 24.4165 26.25H11.5832C11.3401 26.25 11.1069 26.1534 10.935 25.9815C10.7631 25.8096 10.6665 25.5765 10.6665 25.3333C10.6665 25.0902 10.7631 24.8571 10.935 24.6852C11.1069 24.5133 11.3401 24.4167 11.5832 24.4167ZM18.9165 19.0771L21.8893 16.1053L23.1854 17.4014L17.9998 22.587L12.8143 17.4014L14.1104 16.1053L17.0832 19.0771V8.83334H18.9165V19.0771Z","fill":"white"}})])
          )
        }
      }
    